import { PaymentMethodsConfigurationDto } from '@tiendanube/common';
import { customPaymentsIds } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { CalloutCard } from '@tiendanube/components';
import { RocketIcon } from '@tiendanube/icons';
import {
  FEATURE_MAX_CUSTOM_PAYMENTS,
  FEATURE_ONLY_NUVEM_PAGO_PAYMENTS,
} from 'App/features';
import { CUSTOM_PAYMENTS_IMPROVEMENTS_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { PAYMENTS_ADD_CUSTOM_METHOD_TRANSFERENCIA_PIX_EFECTIVO } from 'config/upsellFlowSources';
import { useUpsellFlow } from 'domains/Billing/UpsellFlow/hooks';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

export interface Result {
  showUpsellBanner: boolean;
  upsellBanner: JSX.Element;
}

export const useUpsellBanner = (
  paymentProviderId: string,
  paymentMethodsConfiguration: PaymentMethodsConfigurationDto,
): Result => {
  const t = useTranslationPayments('customPayment');
  const [hasCustomPaymentsImprovementsTag] = useHasTags(
    CUSTOM_PAYMENTS_IMPROVEMENTS_TAG,
  );

  const hasFreePlan = paymentMethodsConfiguration.maxSelectableTypes === 0;
  const isCustomPaymentApp = customPaymentsIds.includes(paymentProviderId);
  const hasLockedPaymentMethods =
    hasFreePlan ||
    paymentMethodsConfiguration.maxSelectableTypes <
      paymentMethodsConfiguration.paymentMethodAvailability.length;

  const showUpsellBanner =
    hasCustomPaymentsImprovementsTag &&
    isCustomPaymentApp &&
    hasLockedPaymentMethods;

  const upsellTitle = t('upsell.title');

  const calloutTitle = hasFreePlan
    ? t('calloutFromFreePlan.title')
    : t('callout.title');
  const calloutSubtitle = hasFreePlan
    ? t('calloutFromFreePlan.subtitle')
    : t('callout.subtitle');

  const initUpsellFlowToPlanA = useUpsellFlow({
    title: upsellTitle,
    trackingSource: PAYMENTS_ADD_CUSTOM_METHOD_TRANSFERENCIA_PIX_EFECTIVO,
    featureKey: FEATURE_ONLY_NUVEM_PAGO_PAYMENTS,
    minValue: 1,
  });

  const initUpsellFlowToPlanB = useUpsellFlow({
    title: upsellTitle,
    trackingSource: PAYMENTS_ADD_CUSTOM_METHOD_TRANSFERENCIA_PIX_EFECTIVO,
    featureKey: FEATURE_MAX_CUSTOM_PAYMENTS,
    minValue: 2,
  });

  const upsellBanner = (
    <CalloutCard
      appearance="primary"
      icon={RocketIcon}
      title={calloutTitle}
      subtitle={calloutSubtitle}
      onClick={hasFreePlan ? initUpsellFlowToPlanA : initUpsellFlowToPlanB}
    />
  );

  return {
    showUpsellBanner,
    upsellBanner,
  };
};
